import EditDealRoom from './EditDealRoom.page';

export default EditDealRoom;
